function updateAditionalInsurance(cargoValue, selectedPlan) {
  const plan = `${selectedPlan || ""}`.trim().toLowerCase();
  if (plan === "minimum") return 25;
  if (plan === "basic") return 35;

  if (cargoValue === null || cargoValue === undefined || cargoValue === "") return 35;

  const value = Number(cargoValue);
  if (!Number.isFinite(value)) return 35;
  if (value > 0 && value <= 15000) return 25;
  if (value <= 25000) return 35;
  if (value > 25000) return value * 0.0017;
  return 35;
}

export default updateAditionalInsurance;
